import { Entity } from '@data-client/rest';
class AuthenticatorRegistrationEntity extends Entity {
    constructor() {
        super(...arguments);
        this.authenticatorUri = '';
        this.sharedKey = '';
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
AuthenticatorRegistrationEntity.key = 'AuthenticatorRegistration';
export { AuthenticatorRegistrationEntity };
